import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { IoMdSearch, IoMdNotifications, IoMdArrowBack } from "react-icons/io";
import { MdArrowDropDown } from "react-icons/md";
import { useAuth } from "../../../context/AuthContext";
import { USER_URL } from "../../../constant/api";
import { FaBars } from "react-icons/fa";
import AdminSidebar from "../AdminSidebar/AdminSidebar";

const AdminNavbar = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { logout } = useAuth();
  const location = useLocation();
  const [personalInfo, setPersonalInfo] = useState({});
  const [isMenuOpen, setIsMenuOpen] = useState(false);


  useEffect(() => {
    const fetchPersonalInfo = async () => {
      try {
        const response = await USER_URL.get(`/accounts/profile-update/`);
        setPersonalInfo(response.data.Data[0]);
        console.log("profile",response.data.Data[0]);
        
      } catch (error) {
        console.error("Error fetching personal info:", error);
      }
    };
    fetchPersonalInfo();
  }, []);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  return (
    <div className="w-full">
      <div className="flex items-center justify-between p-4">
        {/* Sidebar toggle icon for mobile screens */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="mr-4 lg:hidden"
        >
          <FaBars className="text-2xl text-gray-600" />
        </button>
        {/* Left Section: Back Button and Search Bar */}
        <div className="flex items-center space-x-4">
          <button onClick={() => window.history.back()} className="border border-gray-300 rounded-lg p-2">
            <IoMdArrowBack className="text-2xl text-gray-600" />
          </button>
          <div className="relative w-64">
            <input
              type="text"
              placeholder="Search"
              className="w-full rounded-md border border-gray-300 py-2 pl-10 pr-4 focus:outline-none"
            />
            <IoMdSearch className="absolute left-3 top-1/2 -translate-y-1/2 transform text-2xl text-gray-500" />
          </div>
        </div>

        {/* Right Section: Notifications and Profile Dropdown */}
        <div className="flex items-center space-x-4">
          {/* Notifications */}
          <div className="relative">
            <Link to="/admin/notification"
              className={`block rounded-xl p-2 ${location.pathname === "/admin/notification"
                ? "border-2 border-brand-primary"
                : ""
                } text-gray-700 hover:bg-[#CDF2CC]`}
            >

              <IoMdNotifications className="text-2xl text-gray-600" />
              {/* <span className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-xs font-bold text-white">
                3
              </span> */}
            </Link>
          </div>

          {/* Profile Dropdown */}
          <div className="relative" ref={dropdownRef}>
            <div className="flex cursor-pointer items-center" onClick={toggleDropdown}>
              <img
                src="/images/logo/icon_sg.png"
                alt="Admin Avatar"
                className="h-8 w-8 rounded-full"
              />
              <div className="ml-2">
                <p className="text-sm font-semibold">
                  {/* {personalInfo.username || "Admin"} */}
                  Admin
                </p>
                <p className="text-xs text-gray-500">{personalInfo.email}</p>
              </div>
              <MdArrowDropDown className="ml-1 text-xl text-gray-600" />
            </div>

            {/* Dropdown Menu */}
            {isDropdownOpen && (
              <div className="absolute right-0 mt-2 w-48 rounded-lg border bg-white shadow-lg" >
                {/* <Link to="/admin/profile" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">
                  Profile
                </Link> */}
                {/* <Link to="/settings" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">
                  Settings
                </Link> */}
                <button
                  onClick={logout}
                  className="block w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100"
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
        {/* Sidebar for mobile screens */}
        {isMenuOpen && (
          <>
            <div
              className="fixed inset-0 z-40 bg-black opacity-50 lg:hidden"
              onClick={() => setIsMenuOpen(false)}
            ></div>
            <div className="fixed inset-y-0 left-0 z-50 w-64 bg-white shadow-lg lg:hidden">
              <AdminSidebar />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AdminNavbar;
